import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import {
  EVENT_SESSION_EXPIRED,
  shouldDeferHardRedirect,
} from '../utils/sessionIdle';

// Configuración base de axios
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar el token de autenticación
api.interceptors.request.use(
  (config) => {
    // Verificar ambos storages para obtener el token
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Las peticiones automáticas NO deben pasar por /activity; este cliente no lo hace.
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar respuestas
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const savedShowModal = sessionStorage.getItem('pdfEditor_showShareModal')
      const defer = savedShowModal === 'true' || shouldDeferHardRedirect()

      window.dispatchEvent(new CustomEvent(EVENT_SESSION_EXPIRED, {
        detail: {
          source: 'axios',
          code: error.response?.data?.detail?.code || null,
          defer,
        },
      }))

      if (defer) {
        // No redirigir: el editor / modal deben conservar el estado en pantalla.
        return Promise.reject(error);
      }

      localStorage.removeItem('token');
      localStorage.removeItem('user');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');

      setTimeout(() => {
        if (!shouldDeferHardRedirect()) {
          window.location.href = '/login';
        }
      }, 100);
    }
    return Promise.reject(error);
  }
);

export default api;
